const mainConfig = {
  errorMessages: {
    inputErrorClassName: '_error',
  },
};

export default mainConfig;
